import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import clientConfig from '../../../client/config';

import styles from '../TimelineEntry/TimelineEntry.scss';

interface Props {
  activityId: string;
}

export const StravaLink: FunctionComponent<Props> = ({ activityId }) => {
  const { t } = useTranslation('common', { useSuspense: false });
  return (
    <a
      className={styles.stravaLink}
      href={`${clientConfig.strava.activitiesUrl}/${activityId}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('strava.link.ariaLabel')}
    >
      {t('strava.link.view', 'View on Strava')}
    </a>
  );
};
